var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-container" } },
    [
      _c("div", { staticClass: "app-topbar" }, [
        _c(
          "div",
          { staticClass: "title-bar" },
          [
            _c("div", { staticClass: "menu-toggle" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.menuOpen = !_vm.menuOpen
                    },
                  },
                },
                [
                  !_vm.menuOpen
                    ? _c("i", { staticClass: "img icon-menu-white-17" })
                    : _c("i", { staticClass: "img icon-cross-white-12" }),
                ]
              ),
            ]),
            _c("div", { staticClass: "logo" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.navigateHome()
                    },
                  },
                },
                [_c("i", { staticClass: "img logo-aveco-white-36h" })]
              ),
            ]),
            _c("app-switcher", { attrs: { current: "mijn-aveco" } }),
            _c("div", { staticClass: "user" }, [
              _c("div", { staticClass: "user-info" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$user.firstName) +
                      " " +
                      _vm._s(_vm.$user.lastName)
                  ),
                ]),
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.logout()
                      },
                    },
                  },
                  [_vm._v("Uitloggen")]
                ),
              ]),
              _c("div", { staticClass: "avatar" }, [
                _vm._v(_vm._s(_vm._f("userInitials")(_vm.$user))),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "app-wrapper" }, [
        _c(
          "div",
          { staticClass: "app-sidebar", class: { visible: _vm.menuOpen } },
          [
            _c(
              "cms-menu",
              { attrs: { slot: "menu" }, slot: "menu" },
              [
                _c("cms-menu-group", { attrs: { title: "Menu" } }),
                _vm.$can("ROUTE_USERS")
                  ? _c("cms-menu-item", {
                      attrs: {
                        title: "Gebruikers",
                        icon: "magicon-user",
                        route: "users",
                      },
                    })
                  : _vm._e(),
                _vm.$can("ROUTE_PROJECTS")
                  ? _c("cms-menu-item", {
                      attrs: {
                        title: "Projecten",
                        icon: "magicon-folder-opened",
                        route: "projects",
                      },
                    })
                  : _vm._e(),
                _vm.$can("ROUTE_ACCOUNT")
                  ? _c("cms-menu-item", {
                      attrs: {
                        title: "Account",
                        icon: "magicon-user",
                        route: "account",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "app-content",
            on: {
              click: function ($event) {
                _vm.menuOpen = false
              },
            },
          },
          [_c("router-view")],
          1
        ),
      ]),
      _c("transition", { attrs: { name: "fade", duration: 200 } }, [
        _vm.$modal.visible.length
          ? _c(
              "div",
              { staticClass: "cms-shader", on: { click: _vm.onShaderClick } },
              [
                _c("modal-container", {
                  ref: "modalContainer",
                  staticClass: "modal-container",
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("toast-container"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }